import { FormControl, FormGroup } from '@angular/forms';

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

export type Override<What, With> = Omit<What, keyof With> & With;

export class FormGroupOfType<Type> extends FormGroup<{
  [key in keyof Type]: Type[key] extends FormGroupOfType<infer GType> ? FormGroupOfType<GType> : FormControl<Type[key]>;
}> {}

export type Key<T> = keyof T & string;

export type Entry<T> = [Key<T>, T[Key<T>]];

export type Numerated<CommonName extends string, NumbersRange extends number, Type = unknown> = {
  [Number in NumbersRange as `${CommonName}${Number}`]: Type;
};

export type Aliased<Table, Alias extends string> = {
  [Key in keyof Table as `${Alias}.${string & Key}`]: Table[Key];
};

export type KeysOfType<T, Type> = {
  [K in Key<T>]: T[K] extends Type ? K : never;
}[Key<T>];
